var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconFullscreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 1c-1.093 0-2 .907-2 2v4h2V3h4V1zm10 0v2h4v4h2V3c0-1.093-.907-2-2-2zM1 13v4c0 1.093.907 2 2 2h4v-2H3v-4zm16 0v4h-4v2h4c1.093 0 2-.907 2-2v-4z"
})));
export default SvgIconFullscreen;